import './SFNT.scss';
import {PageManager} from '@mvps-genesis/bootstrap';
import 'custom-extensions/searchspring-recommendations';

export default class SFNT extends PageManager {

	constructor (pageContext) {

		super(pageContext);

	}

}
